import getUsers from './getUsers';

export default function getUsersCount(state) {
  return getUsers(state).length;
}
